import * as React from 'react';

// tslint:disable:max-line-length
export const CanalIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M8.5 3c1.2 0 2.2.4 3.2 1H9v2h6V0h-2v2.5C11.7 1.5 10.2 1 8.5 1 4.6 1 1.3 4 1 7.9l2 .2C3.2 5.2 5.6 3 8.5 3zM7.5 13c-1.2 0-2.2-.4-3.2-1H7v-2H1v6h2v-2.5c1.3 1 2.8 1.5 4.5 1.5 3.9 0 7.2-3 7.5-6.9l-2-.2c-.2 2.9-2.6 5.1-5.5 5.1z" />
    </g>
  </svg>
);
